import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);

    const links = [
        { label: 'Partners', href: '#partners' },
        { label: 'Product', href: '#product' },
        { label: 'Solutions', href: '#solutions' },
        { label: 'Pricing', href: '#pricing' },
        { label: 'Use cases', href: '/use-cases/' },
        { label: 'Watch the demo', href: '/watch/', demo: true },
    ];

    return (
        <div className="fixed top-0 lg:top-6 left-0 right-0 z-50 px-0 lg:px-6">
            <nav className={`flex justify-between items-center gap-6 px-6 lg:px-7 py-4 lg:py-3 max-w-[1240px] mx-auto w-full bg-card/95 backdrop-blur-md border-b lg:border border-borderLight lg:shadow-hard-soft lg:rounded-2xl transition-all duration-300 ${isOpen ? 'h-[100dvh] lg:h-auto items-start lg:items-center flex-col lg:flex-row' : 'h-auto'}`}>
                {/* Left: Logo & Mobile Toggle */}
                <div className="flex items-center justify-between w-full lg:w-auto flex-shrink-0">
                    <div className="flex items-center gap-2.5">
                        <span className="w-11 h-11 lg:w-12 lg:h-12 rounded-full bg-ink shadow-hard-soft overflow-hidden flex items-center justify-center flex-shrink-0">
                            <img src="/new_logo.png" alt="Vetobase AI" className="w-full h-full object-cover rounded-full" />
                        </span>
                        <span className="text-xl font-bold tracking-head text-ink whitespace-nowrap">Vetobase <span className="font-serif-italic">AI</span></span>
                    </div>

                    <button
                        onClick={() => setIsOpen(!isOpen)}
                        className="w-10 h-10 grid place-items-center rounded-full border border-borderLight lg:hidden text-ink hover:bg-bone transition-colors"
                        aria-label="Menu"
                    >
                        {isOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
                    </button>
                </div>

                {/* Center: Navigation Links */}
                <div className={`${isOpen ? 'flex flex-col mt-12 gap-8 w-full' : 'hidden lg:flex'} items-center gap-6 xl:gap-8`}>
                    {links.map((link) => (
                        <a
                            key={link.label}
                            href={link.href}
                            {...(link.demo ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                            onClick={() => setIsOpen(false)}
                            className={`text-[16px] lg:text-[13px] whitespace-nowrap transition-colors w-full text-center lg:w-auto ${link.demo ? 'font-bold text-ink underline underline-offset-4 decoration-2' : 'font-medium text-textSecondary hover:text-ink'}`}
                        >
                            {link.label}
                        </a>
                    ))}
                </div>

                {/* Right: Contact + Go to workspace */}
                <div className={`${isOpen ? 'mt-auto mb-12 w-full px-4 flex flex-col gap-3' : 'hidden lg:flex items-center gap-2.5 flex-shrink-0'}`}>
                    <a
                        href="#contact"
                        onClick={() => setIsOpen(false)}
                        className="block w-full lg:w-auto whitespace-nowrap text-center bg-card text-ink border border-ink px-8 lg:px-5 py-4 lg:py-2.5 rounded-full text-base lg:text-sm font-semibold hover:bg-bone transition-all"
                    >
                        Contact
                    </a>
                    <a
                        href="https://app.vetobase.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => setIsOpen(false)}
                        className="inline-flex w-full lg:w-auto whitespace-nowrap items-center justify-center gap-2 text-center bg-ink text-paper px-8 lg:px-5 py-4 lg:py-2.5 rounded-full text-base lg:text-sm font-semibold shadow-hard-soft hover:bg-black transition-all active:translate-x-[2px] active:translate-y-[2px]"
                    >
                        Go to workspace
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12h14" /><path d="m12 5 7 7-7 7" /></svg>
                    </a>
                </div>
            </nav>
        </div>
    );
};

export default Navbar;
